var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-account-image-wrapper"},[_c('img',{staticClass:"a-account-image",attrs:{"src":"assets/imgs/header-bg-min.jpg","loading":"lazy","alt":""}}),_c('div',{staticClass:"a-section-regular"},[_c('div',{staticClass:"a-container-regular"},[_c('div',{staticClass:"a-account-form-wrapper"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }